import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeeService } from '../service/fee.service';

export interface GroupNameEditDialogData {
  groupId: number;
  currentName: string;
}

@Component({
  selector: 'app-fee-group-name-edit-dialog',
  templateUrl: './fee-group-name-edit-dialog.component.html',
  styleUrls: ['./fee-group-name-edit-dialog.component.scss']
})
export class GroupNameEditDialogComponent implements OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  form!: FormGroup;
  saving = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<GroupNameEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: GroupNameEditDialogData,
    private readonly feeService: FeeService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      companyName: [this.data.currentName, [Validators.required, Validators.maxLength(25)]]
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  save(): void {
    if (this.form.invalid || this.saving) return;
    this.saving = true;

    this.feeService.updateGroupName(this.data.groupId, this.form.value.companyName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close(this.form.value.companyName),
        error: () => { this.saving = false; }
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
